export const locale = {
  lang: 'de',
  data: {
    'CHANGELOG': {
      'TITULO': 'Änderungsprotokoll',
      'SUBTITULO': 'Überprüfen Sie die Aktualisierungen der Plattform im Laufe der Zeit',
      'ULTIMA': 'Letztes Update',
      'CATEGORIAS': {
        'Changed': 'Aktualisierung',
        'Fixed': 'Korrekturen',
        'Added': 'Verbesserungen'
      }
    },
    'KNOWLEDGE': {
      'LINK': 'Klicken Sie auf diesen Link, wenn die Plattform Sie nicht automatisch weiterleitet'
    }
  }
};
